import { defineComponent as a, h as o } from "vue";
import f from "./ghl-ui.es380.js";
import { NPerformantEllipsis as c } from "./ghl-ui.es666.js";
import u from "./ghl-ui.es759.js";
const v = a({
  name: "DataTableCell",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    row: {
      type: Object,
      required: !0
    },
    index: {
      type: Number,
      required: !0
    },
    column: {
      type: Object,
      required: !0
    },
    isSummary: Boolean,
    mergedTheme: {
      type: Object,
      required: !0
    },
    renderCell: Function
  },
  render() {
    var s;
    const {
      isSummary: p,
      column: l,
      row: r,
      renderCell: m
    } = this;
    let e;
    const {
      render: d,
      key: n,
      ellipsis: i
    } = l;
    if (d && !p ? e = d(r, this.index) : p ? e = (s = r[n]) === null || s === void 0 ? void 0 : s.value : e = m ? m(u(r, n), r, l) : u(r, n), i)
      if (typeof i == "object") {
        const {
          mergedTheme: t
        } = this;
        return l.ellipsisComponent === "performant-ellipsis" ? o(c, Object.assign({}, i, {
          theme: t.peers.Ellipsis,
          themeOverrides: t.peerOverrides.Ellipsis
        }), {
          default: () => e
        }) : o(f, Object.assign({}, i, {
          theme: t.peers.Ellipsis,
          themeOverrides: t.peerOverrides.Ellipsis
        }), {
          default: () => e
        });
      } else
        return o("span", {
          class: `${this.clsPrefix}-data-table-td__ellipsis`
        }, e);
    return e;
  }
});
export {
  v as default
};
